export default __webpack_public_path__ + "assets/webgl/scene-17.f1536186.glb";